import { getSessionUUID, getUUID } from '@/lib';
import Cookies from 'js-cookie';
import { create } from 'zustand';

// getBreadcrumbs,
// getPageURL,
// showProductEditorNavigation,
// showProductEditorPreview,
// showPreview,
// setShowNavigation,
// setShowProductEditorPreview,

export interface Breadcrumb {
    title: string;
    to: string;
    query?: Record<string, string>;
    params?: Record<string, string>;
    active?: boolean;
    id: string;
}

export interface GlobalStore {
    breadcrumbs: Breadcrumb[];
    pageURL: string;
    showProductEditorNavigation: boolean;
    showProductEditorPreview: boolean;
    showPreview: boolean;
    ipAddress: string;
    deviceToken: string;
    UUID: string;
    sessionUUID: string;

    // setters
    setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
    setShowNavigation: (show: boolean) => void;
    setShowProductEditorPreview: (show: boolean) => void;
    setIpAddress: (ipAddress: string) => void;
    setDeviceToken: (deviceToken: string) => void;

    // getters
    getDeviceToken: () => string;
}

export const useGlobalStore = create<GlobalStore>((set, get) => ({
    breadcrumbs: [],
    pageURL: '',
    showProductEditorNavigation: false,
    showProductEditorPreview: false,
    showPreview: false,
    ipAddress: '',
    deviceToken: '',
    UUID: getUUID(),
    sessionUUID: getSessionUUID(),

    setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => set({ breadcrumbs }),
    setShowNavigation: (show: boolean) => set({ showProductEditorNavigation: show }),
    setShowProductEditorPreview: (show: boolean) => set({ showProductEditorPreview: show }),
    setIpAddress: (ipAddress: string) => set({ ipAddress }),
    setDeviceToken: (deviceToken: string) => set({ deviceToken }),

    getDeviceToken: () => {
        if (get().deviceToken === '' && Cookies.get('x-session-id') !== '') {
            set({ deviceToken: Cookies.get('x-session-id') });
        }

        const in1Year = 1 * 365; // js-cookies uses days as base unit
        Cookies.set('x-session-id', get().deviceToken, { expires: in1Year });
        Cookies.set('x-session-id', get().deviceToken, { domain: 'stanwith.me', expires: in1Year });
        Cookies.set('x-session-id', get().deviceToken, { domain: 'stan.store', expires: in1Year });

        return get().deviceToken;
    },
}));
